import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';

import { FeedbackActionsEnum } from '../enums/FeedbackActionsEnum';
import { IFeedbackState } from '../interfaces/IFeedbackState';
import { FeedbackAction } from '../types/FeedbackAction';

const initialState: IFeedbackState = {
  files: [],
};

export function feedbackReducer(state = initialState, action: FeedbackAction): IFeedbackState {
  switch (action.type) {
    case FeedbackActionsEnum.FEEDBACK_RESET: {
      return initialState;
    }
    case FeedbackActionsEnum.FEEDBACK_SET_FILES: {
      const { files } = action.payload;
      const newState = {
        ...state,
        files,
      };
      return newState;
    }
    case FeedbackActionsEnum.FEEDBACK_SET_KNM_DATA: {
      const { knmData } = action.payload;
      const newState: IFeedbackState = {
        ...state,
        knmData,
      };

      return newState;
    }
    case FeedbackActionsEnum.FEEDBACK_SET_FORM: {
      const { form } = action.payload;
      const newState: IFeedbackState = {
        ...state,
        form,
      };

      return newState;
    }
    default:
      return state;
  }
}

export const getFeedbackFiles = (state: IRootState) => state.feedback.files;
export const getFeedbackKnmData = (state: IRootState) => state.feedback.knmData;
